import {IRole} from '../../../models/IRole'
import {ID} from '../../../../_metronic/helpers'

export type AuthMode = 'portal' | 'exam'

export interface AuthModel {
  api_token: string
  refreshToken?: string
  authMode?: AuthMode
}

export interface IAuthRequest {
  username: string
  password: string
  captchaToken?: string
}

export interface IBaseResponse<T> {
  code: string
  data: T
  message: string
}

export interface IInfiteScrollData<T> {
  nextPage?: number
  pageNumber: number
  pageSize: number
  records: T[]
  totalPages: number
  totalRecords: number
  totalRecordsFiltered: number
}

export interface IAuthResponse {
  userInfo: IUserInfo
  token: string
  guid: string
  isWaitOtp: boolean
}

export interface IAuthExamResponse extends IAuthResponse {
  classId: number
  courseQuizId: number
}

export interface IUserInfo {
  id: number
  name: string
  loginName: string
  roles: IRole[]
  password: null | string
  managerId: null | string
  memberId: null | string
  memberName: null | string
  memberType: null | string
  userType: number
  userTypeName: null | string
  utcOffset: string
  timeZone: null | string
  timeZoneInfo: {
    id: string
    hasIanaId: boolean
    displayName: string
    standardName: string
    daylightName: string
    baseUtcOffset: string
    supportsDaylightSavingTime: boolean
  }
  additionalInfo: Record<string, any>
}

export interface UserAddressModel {
  addressLine: string
  city: string
  state: string
  postCode: string
}

export interface UserCommunicationModel {
  email: boolean
  sms: boolean
  phone: boolean
}

export interface UserEmailSettingsModel {
  emailNotification?: boolean
  sendCopyToPersonalEmail?: boolean
  activityRelatesEmail?: {
    youHaveNewNotifications?: boolean
    youAreSentADirectMessage?: boolean
    someoneAddsYouAsAsAConnection?: boolean
    uponNewOrder?: boolean
    newMembershipApproval?: boolean
    memberRegistration?: boolean
  }
  updatesFromKeenthemes?: {
    newsAboutKeenthemesProductsAndFeatureUpdates?: boolean
    tipsOnGettingMoreOutOfKeen?: boolean
    thingsYouMissedSindeYouLastLoggedIntoKeen?: boolean
    newsAboutStartOnPartnerProductsAndOtherServices?: boolean
    tipsOnStartBusinessProducts?: boolean
  }
}

export interface UserSocialNetworksModel {
  linkedIn: string
  facebook: string
  twitter: string
  instagram: string
}

export interface UserModel {
  id: number
  username: string
  password?: string | undefined
  email: string
  name: string
  roleId: number
  roleName: string
  roles?: IRole[] | null
  majorName: string
  degreeName: string
  nim: string
  limitFileSize: number
  limitFileSizeMb: number
  staffMajors?: any[] | null
  isQuizCreator?: boolean
}

export interface MenuModel {
  seq?: number
  title: string
  code?: string
  route: string
  icon: string
  isGroup: boolean
  isExt?: boolean
  children?: Array<MenuModel> | undefined
  canCreate?: boolean
  canDelete?: boolean
  otherAccess?: string[] | null
}

export interface SatkerModel {
  id: ID
  name: string
  alias: string
}

export interface OfficerRankModel {
  id: ID
  code: string
  name: string
}

export const hasOtherAccess = (model: MenuModel | undefined, key: string) => {
  return model?.otherAccess?.includes(key)
}
